export default __webpack_public_path__ + "static/media/farm_challenge_lack_fertilizer.5da3a72e.jpg";